import { render, staticRenderFns } from "./PatchColorItem.vue?vue&type=template&id=5f7669fa&scoped=true&"
import script from "./PatchColorItem.vue?vue&type=script&lang=js&"
export * from "./PatchColorItem.vue?vue&type=script&lang=js&"
import style0 from "./PatchColorItem.vue?vue&type=style&index=0&id=5f7669fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7669fa",
  null
  
)

export default component.exports